export function resourcesNamespace(http) {
    return {
        /** Fetch a single resource by id. Unwraps the envelope → `{ resource }`. */
        get(resourceId, opts) {
            return http.get(`/resources/${resourceId}`, { signal: opts?.signal });
        },
        /**
         * List resources (DB-backed). Returns the raw envelope so the `meta`
         * pagination sibling survives (`{ success, data: { resources }, meta }`).
         */
        list(params = {}) {
            const { signal, ...query } = params;
            return http.get('/resources', { query, signal, raw: true });
        },
        /** Fetch the catalogue (ES- or DB-backed) for a collection, with facets. */
        catalogue(collectionId, params = {}) {
            const { facets, signal, ...query } = params;
            return http.get(`/catalogue/${collectionId}`, { query, facets, signal });
        },
        /** Create a resource (JSON). Unwraps → `{ resource }`; throws on failure. */
        create(body) {
            return http.post('/resources', { body });
        },
        /** Update a resource (JSON). Unwraps → `{ resource }`; throws on failure. */
        update(resourceId, body) {
            return http.put(`/resources/${resourceId}`, { body });
        },
        /** Delete a resource. Drafts are removed outright; anything else is soft-deleted into the trash. */
        delete(resourceId) {
            return http.delete(`/resources/${resourceId}`);
        },
        /**
         * Move many resources along the lifecycle at once (max 200) — the bulk
         * publish/withdraw. Resolves with a partial-success report; throws only
         * when not one id could be applied.
         */
        bulkState(resourceIds, state) {
            return http.post('/resources/bulk/state', {
                body: { resource_ids: resourceIds, state },
                raw: true,
            });
        },
        /**
         * Add or remove a set of tags across many resources (max 200).
         *
         * Additive/subtractive, unlike `semanticTags.syncResource`, which replaces
         * one resource's whole tag set — adding a tag to forty resources must not
         * wipe the tags each of them already carries.
         */
        bulkSemanticTags(resourceIds, tagIds, mode) {
            return http.post('/resources/bulk/semantic-tags', {
                body: { resource_ids: resourceIds, tag_ids: tagIds, mode },
                raw: true,
            });
        },
        /** Restore previously-cleared AI suggestions for a resource. */
        restoreAiSuggestions(resourceId) {
            return http.post(`/resources/${resourceId}/ai-suggestions/restore`);
        },
        /** Clear AI suggestions on a single file of a resource. */
        clearFileAiSuggestions(resourceId, fileId) {
            return http.delete(`/resources/${resourceId}/files/${fileId}/ai-suggestions`);
        },
        /**
         * Upload a file to a resource (multipart). Pass `onProgress` for an XHR
         * upload with progress; the caller builds the FormData (File, role, etc.).
         */
        uploadFile(resourceId, formData, opts) {
            return http.upload(`/resources/${resourceId}/files`, formData, opts);
        },
    };
}
//# sourceMappingURL=resources.js.map